import React from 'react';

import { fields } from 'modules';

import * as dataService from './dataService';



interface IProps {
  label?: React.ReactNode;
}

export const USStateSelectField = (props?: IProps) => {
  return fields.genEnumSelectFieldComponent(dataService.useUSStateSelectField, {
    label: props?.label
  });
};
